/* eslint jsx-a11y/anchor-is-valid: "off" */

import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import Link, { navigateTo } from 'gatsby-link';
import * as qs from 'qs';
import * as _ from 'lodash';
import { CSSTransition } from 'react-transition-group';
import { ucfirst } from '../../shared/utils';
import './search.scss';

class Search extends Component {
  static propTypes = {
    in: PropTypes.bool.isRequired,
    onClose: PropTypes.func,
    tags: PropTypes.object
  };

  static defaultProps = {
    onClose: () => {},
    tags: []
  };

  constructor(props) {
    super(props);

    this.searchInput = React.createRef();

    this.onEntered = this.onEntered.bind(this);
    this.onKeyPress = this.onKeyPress.bind(this);
    this.close = this.close.bind(this);
  }

  state = {
    entered: false
  };

  onEntered() {
    this.setState({ entered: true });
  }

  onKeyPress(e) {
    if (e.key === 'Enter') {
      e.preventDefault();
      navigateTo(`/search?${qs.stringify({ q: this.searchInput.current.value })}`);
      this.close();
    }
  }

  close() {
    this.setState({ entered: false });
    this.props.onClose();
  }

  render() {
    const tags = Array.from(this.props.tags)
      .filter(i => !!i)
      .sort((a, b) => a.toLowerCase().localeCompare(b.toLowerCase()))
      .slice(0, 10);

    return (
      <Fragment>
        <CSSTransition
          in={this.props.in}
          timeout={{
            enter: 300,
            exit: 250
          }}
          classNames="fade"
          mountOnEnter
          unmountOnExit
        >
          <div className="search-overlay" onClick={this.close} role="presentation" />
        </CSSTransition>
        <CSSTransition
          in={this.props.in}
          timeout={{
            enter: 100,
            exit: 150
          }}
          classNames="drop"
          mountOnEnter
          unmountOnExit
          onEnter={this.onEntered}
        >
          <div className="search-bar">
            <div className="search-inner layout">
              <CSSTransition
                in={this.state.entered}
                timeout={{
                  enter: 200,
                  exit: 150
                }}
                classNames="slide-left"
                mountOnEnter
                unmountOnExit
              >
                <div className="search-left">
                  <div className="search-form">
                    <span>
                      <i className="fw-search" />
                    </span>
                    <form>
                      <input
                        type="search"
                        placeholder="Search..."
                        onKeyPress={this.onKeyPress}
                        ref={this.searchInput}
                      />
                    </form>
                  </div>
                  <div className="search-tags">
                    <ul>
                      {tags.map(tag => (
                        <li key={tag}>
                          <Link to={`/tags/${_.kebabCase(tag)}`}>#{ucfirst(tag)}</Link>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </CSSTransition>
              <button className="search-close" onClick={this.close}>
                <i className="fw-close" />
              </button>
            </div>
          </div>
        </CSSTransition>
      </Fragment>
    );
  }
}

export default Search;



// WEBPACK FOOTER //
// ./src/components/Search/Search.jsx